module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1531-b3ab34e0747ff8433e81f5a1e448d0be.png";